module.exports = __webpack_public_path__ + "img/ring_y_i_1_null@3x.87b97063.png";